<template>
  <div class="tw-bg-white tw-mt-7 tw-mb-10">
    <WdsStack direction-column align-center>
      <h2 class="tw-mt-4 tw-mb-8 tw-font-normal">{{ $t('Welcome to Worksome') }} &#x1F44B;</h2>

      <WdsStack justify-space-between wrap class="tw-px-6">
        <div class="tw-w-full lg:tw-w-1/5 tw-mb-7 lg:tw-mb-0">
          <div class="m-b-15 line-height-1">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27 16.76V15.23L28.92 13.55C29.6507 12.906 29.8112 11.8292 29.3 11L26.94 7.00004C26.5831 6.38188 25.9238 6.00078 25.21 6.00004C24.9927 5.99838 24.7765 6.03216 24.57 6.10004L22.14 6.92004C21.7205 6.64125 21.2828 6.3907 20.83 6.17004L20.32 3.65004C20.1313 2.69981 19.2886 2.02148 18.32 2.04004H13.64C12.6714 2.02148 11.8287 2.69981 11.64 3.65004L11.13 6.17004C10.6739 6.39065 10.233 6.64119 9.81 6.92004L7.43 6.06004C7.2213 6.00567 7.00518 5.98541 6.79 6.00004C6.0762 6.00078 5.4169 6.38188 5.06 7.00004L2.7 11C2.2186 11.8271 2.39047 12.8792 3.11 13.51L5 15.24V16.77L3.11 18.45C2.36925 19.086 2.19595 20.1639 2.7 21L5.06 25C5.4169 25.6182 6.0762 25.9993 6.79 26C7.00735 26.0017 7.22352 25.9679 7.43 25.9L9.86 25.08C10.2795 25.3588 10.7172 25.6094 11.17 25.83L11.68 28.35C11.8687 29.3003 12.7114 29.9786 13.68 29.96H18.4C19.3686 29.9786 20.2113 29.3003 20.4 28.35L20.91 25.83C21.3661 25.6094 21.807 25.3589 22.23 25.08L24.65 25.9C24.8565 25.9679 25.0727 26.0017 25.29 26C26.0038 25.9993 26.6631 25.6182 27.02 25L29.3 21C29.7814 20.173 29.6095 19.1209 28.89 18.49L27 16.76ZM10 16C10 19.3137 12.6863 22 16 22C17.5962 22.0162 19.1318 21.3893 20.2606 20.2605C21.3893 19.1318 22.0162 17.5962 22 16C22 12.6863 19.3137 10 16 10C12.6863 10 10 12.6863 10 16ZM13.1442 13.1442C13.8998 12.3885 14.9317 11.9751 16 12C17.0683 11.9751 18.1003 12.3885 18.8559 13.1442C19.6115 13.8998 20.0249 14.9317 20 16C20.0249 17.0683 19.6115 18.1002 18.8559 18.8558C18.1003 19.6115 17.0683 20.0249 16 20C14.9317 20.0249 13.8998 19.6115 13.1442 18.8558C12.3886 18.1002 11.9751 17.0683 12 16C11.9751 14.9317 12.3886 13.8998 13.1442 13.1442ZM21.78 22.84L25.21 24L27.57 20L24.85 17.53C25.0349 16.4949 25.0349 15.4352 24.85 14.4L27.57 12L25.21 8.00004L21.77 9.12004C20.9643 8.44919 20.0516 7.91847 19.07 7.55004L18.36 4.00004H13.64L12.93 7.59004C11.9406 7.9483 11.0229 8.47994 10.22 9.16004L6.79 8.00004L4.43 12L7.15 14.47C6.9651 15.5052 6.9651 16.5649 7.15 17.6L4.43 20L6.79 24L10.23 22.88C11.0357 23.5509 11.9484 24.0816 12.93 24.45L13.64 28H18.36L19.07 24.41C20.0594 24.0518 20.9771 23.5202 21.78 22.84Z"
                fill="#0E0D12"
              />
            </svg>
          </div>
          <h4 class="tw-font-medium tw-text-lg">1. {{ $t('Set up your account') }}</h4>
          <p class="tw-text-gray-700">
            {{
              $t('Update your settings and add your business entity, banking & tax information.')
            }}
          </p>
        </div>

        <div class="tw-w-full lg:tw-w-1/5 tw-mb-7 lg:tw-mb-0">
          <div class="m-b-15 line-height-1">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14 20.18L10.41 16.59L9 18L14 23L23 14L21.59 12.58L14 20.18ZM25 5H22V4C22 2.89543 21.1046 2 20 2H12C10.8954 2 10 2.89543 10 4V5H7C5.89543 5 5 5.89543 5 7V28C5 29.1046 5.89543 30 7 30H25C26.1046 30 27 29.1046 27 28V7C27 5.89543 26.1046 5 25 5ZM12 4H20V8H12V4ZM7 28H25V7H22V10H10V7H7V28Z"
                fill="#0E0D12"
              />
            </svg>
          </div>
          <h4 class="tw-font-medium tw-text-lg">2. {{ $t('Get invited to a job') }}</h4>
          <p class="tw-text-gray-700">
            {{ $t('Once your client invites you to a job, you can review & accept the contract.') }}
          </p>
        </div>

        <div class="tw-w-full lg:tw-w-1/5 tw-mb-7 lg:tw-mb-0">
          <div class="m-b-15 line-height-1">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M23 16H21V18H23V16Z" fill="black" />
              <path d="M17 16H9V18H17V16Z" fill="black" />
              <path d="M23 12H21V14H23V12Z" fill="black" />
              <path d="M17 12H9V14H17V12Z" fill="black" />
              <path d="M23 8H9V10H23V8Z" fill="black" />
              <path
                d="M25 2H7C6.46973 2.00053 5.96133 2.21141 5.58637 2.58637C5.21141 2.96133 5.00053 3.46973 5 4V29C5 29.2652 5.10536 29.5196 5.29289 29.7071C5.48043 29.8946 5.73478 30 6 30H7C7.15526 30.0001 7.30841 29.964 7.44728 29.8946C7.58615 29.8251 7.70692 29.7243 7.8 29.6L10 26.667L12.2 29.6C12.2971 29.7182 12.4192 29.8135 12.5576 29.8789C12.6959 29.9442 12.847 29.9781 13 29.9781C13.153 29.9781 13.3041 29.9442 13.4424 29.8789C13.5808 29.8135 13.7029 29.7182 13.8 29.6L16 26.667L18.2 29.6C18.2971 29.7182 18.4192 29.8135 18.5576 29.8789C18.6959 29.9442 18.847 29.9781 19 29.9781C19.153 29.9781 19.3041 29.9442 19.4424 29.8789C19.5808 29.8135 19.7029 29.7182 19.8 29.6L22 26.667L24.2 29.6C24.2931 29.7242 24.4139 29.8251 24.5527 29.8945C24.6916 29.9639 24.8447 30.0001 25 30H26C26.2652 30 26.5196 29.8946 26.7071 29.7071C26.8946 29.5196 27 29.2652 27 29V4C26.9994 3.46975 26.7885 2.9614 26.4135 2.58646C26.0386 2.21152 25.5302 2.00061 25 2ZM25 27.333L22.8 24.4C22.7029 24.2818 22.5808 24.1865 22.4424 24.1211C22.3041 24.0558 22.153 24.0219 22 24.0219C21.847 24.0219 21.6959 24.0558 21.5576 24.1211C21.4192 24.1865 21.2971 24.2818 21.2 24.4L19 27.333L16.8 24.4C16.7029 24.2818 16.5808 24.1865 16.4424 24.1211C16.3041 24.0558 16.153 24.0219 16 24.0219C15.847 24.0219 15.6959 24.0558 15.5576 24.1211C15.4192 24.1865 15.2971 24.2818 15.2 24.4L13 27.333L10.8 24.4C10.7029 24.2818 10.5808 24.1865 10.4424 24.1211C10.3041 24.0558 10.153 24.0219 10 24.0219C9.847 24.0219 9.69589 24.0558 9.55756 24.1211C9.41924 24.1865 9.29712 24.2818 9.2 24.4L7 27.333V4H25V27.333Z"
                fill="black"
              />
            </svg>
          </div>
          <h4 class="tw-font-medium tw-text-lg">3. {{ $t('Create your first bill') }}</h4>
          <p class="tw-text-gray-700">
            {{
              $t(
                'After the bill is approved by your client, an invoice is automatically sent to them.',
              )
            }}
          </p>
        </div>

        <div class="tw-w-full lg:tw-w-1/5">
          <div class="m-b-15 line-height-1">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M26.98 13H29C29.2652 13 29.5196 13.1054 29.7071 13.2929C29.8946 13.4804 30 13.7348 30 14V19C30 19.2652 29.8946 19.5196 29.7071 19.7071C29.5196 19.8946 29.2652 20 29 20H26.8188C26.6674 20.785 26.3333 21.5232 25.8436 22.1551C25.3539 22.787 24.7223 23.2947 24 23.6372V27C24 27.2652 23.8946 27.5196 23.7071 27.7071C23.5196 27.8946 23.2652 28 23 28H19C18.7348 28 18.4804 27.8946 18.2929 27.7071C18.1054 27.5196 18 27.2652 18 27V25H15V27C15 27.2652 14.8946 27.5196 14.7071 27.7071C14.5196 27.8946 14.2652 28 14 28H10C9.73478 28 9.48043 27.8946 9.29289 27.7071C9.10536 27.5196 9 27.2652 9 27V23.5566C7.91201 22.8106 6.99773 21.8387 6.31951 20.7072C5.64129 19.5757 5.2151 18.3112 5.07 17H5C4.20462 16.9991 3.44206 16.6828 2.87964 16.1204C2.31722 15.5579 2.00087 14.7954 2 14V12H4V14C4.00024 14.2651 4.10567 14.5194 4.29316 14.7068C4.48064 14.8943 4.73486 14.9998 5 15H5.0515C5.5366 10.2412 9.4905 7 15 7H19.6665L23.4 4.2C23.5486 4.08857 23.7252 4.02072 23.9102 4.00404C24.0952 3.98736 24.2811 4.02252 24.4472 4.10557C24.6133 4.18863 24.753 4.31629 24.8507 4.47427C24.9483 4.63225 25 4.81429 25 5V8.8525C25.5961 9.37164 26.0795 10.0076 26.42 10.721C26.7606 11.4343 26.9512 12.21 26.98 13ZM25.124 18H28V15H25.0183C25 14.6477 25 14.3166 25 14.0003C25 12.4876 25 11.3142 23 9.7764V7L20.3335 9H15C11.0181 9 7 11.1646 7 16C6.99142 17.3334 7.36315 18.6416 8.07162 19.7712C8.78008 20.9008 9.79591 21.8051 11 22.3779V26H13V23H20V26H22V22.3154C24.3005 21.4854 24.8188 20.7529 25.124 18ZM13 11H20V13H13V11Z"
                fill="#0E0D12"
              />
            </svg>
          </div>
          <h4 class="tw-font-medium tw-text-lg">4. {{ $t('Get paid') }}</h4>
          <p class="tw-text-gray-700">
            {{ $t('Once the invoice is paid, you will receive a payout from Worksome.') }}
          </p>
        </div>
      </WdsStack>

      <div v-if="!isFreelancerOnboarded && !loadingAccount" class="tw-mt-7">
        <a :href="laravelNamedRoute(namedRoutes.frontend.user.profile.edit)">
          <WdsButton primary lg>
            <WdsStack align-center>
              <div>{{ $t('Finish account setup') }}</div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="tw-ml-1.5"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.3 3.7L13.1 7.5H1V8.5H13.1L9.3 12.3L10 13L15 8L10 3L9.3 3.7Z"
                  fill="#FFFFFF"
                  stroke-width="0.2"
                />
              </svg>
            </WdsStack>
          </WdsButton>
        </a>
      </div>
    </WdsStack>
  </div>
</template>

<script setup>
import { WdsButton, WdsStack } from '@worksome/wds-components'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { useFreelancerOnboardingCompliances } from '@/composables/useFreelancerOnboardingCompliances'

const { isFreelancerOnboarded, loadingAccount } = useFreelancerOnboardingCompliances()
</script>
